<template>
  <sidebar-menu 
    :collapsed="collapsed"
    @onItemClicked="$emit('on-item-clicked', $event)"
    @request-system-change="$emit('request-system-change')"
  />
</template>

<script>
import SidebarMenu from './SidebarMenu.vue'
import authStore from "../store/auth-store";

export default {
  components: { SidebarMenu },

  props: {
    collapsed: { type: Boolean, required: true }
  },

  emits: ["on-item-clicked", "request-system-change"],

  watch: {
    collapsed(collapsed) {
      
    },
  },

  computed: {
    user() {
      return authStore.state.user;
    }
  }
}
</script>

<style scoped></style>
